/**
 * Remetentes WhatsApp na API Zenvia: o campo `senderId` deve ser o **número (MSISDN)** cadastrado
 * na Zenvia, não o "ID do número de telefone" da Meta. Os IDs Meta ficam só no rótulo para referência.
 * Lista fixa temporária — pode migrar para API/config depois.
 */
const META_ID_TO_PHONE_DIGITS: Record<string, string> = {
  '1052767977914944': '554195819026',
  '1009743785559436': '554195819062',
  '961274990410318': '554195595096',
};

const KNOWN_PHONE_DIGITS = new Set(Object.values(META_ID_TO_PHONE_DIGITS));

export const ZENVIA_WHATSAPP_SENDER_DROPDOWN_OPTIONS: { key: string; text: string; value: string }[] = [
  {
    key: '9026',
    text: 'Gettel Telecom — +55 41 9581-9026 — ID Meta: 1052767977914944',
    value: '554195819026',
  },
  {
    key: '9062',
    text: 'Gettel Telecom — +55 41 9581-9062 — ID Meta: 1009743785559436',
    value: '554195819062',
  },
  {
    key: '5096',
    text: 'Gettel — +55 41 9559-5096 — ID Meta: 961274990410318',
    value: '554195595096',
  },
];

/** Normaliza o sender vindo do GET (telefone ou, se legado, ID Meta) para o valor do dropdown (MSISDN). */
export function mapTemplateSenderIdToWizardValue(senderId: string): string {
  const t = senderId.trim();
  if (!t) return '';
  if (META_ID_TO_PHONE_DIGITS[t]) return META_ID_TO_PHONE_DIGITS[t];
  const digits = t.replace(/\D/g, '');
  if (digits && KNOWN_PHONE_DIGITS.has(digits)) return digits;
  return t;
}
